import React, { memo } from "react";
import { motion } from "framer-motion";
import { stringFiltroEmbarque } from "../../../../../../models/FiltroEmbarqueCompleto.ts";
import { useFiltro } from "../../../../../../contexts/FiltroContext.tsx";
import Separator from "../../../../../../core/components/Separator.tsx";
import InputTags from "../../data-entry/InputTags.tsx";

function RenderStringFiltros() {
	const { filtroEmbarque } = useFiltro();

	return stringFiltroEmbarque.map(({ key1, key2, title1, title2 }, index) => (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.2, delay: index * 0.05 }}
			key={`${key1}-${key2}`}
			style={{
				minHeight: "100px",
			}}
		>
			<InputTags
				key={`${key1}-input`}
				title={title1}
				filtroKey={key1}
				tags={filtroEmbarque[key1] || []}
			/>
			<Separator size="md" />
			<InputTags
				key={`${key2}-input2`}
				title={title2}
				filtroKey={key2}
				tags={filtroEmbarque[key2] || []}
			/>
		</motion.div>
	));
}

export default memo(RenderStringFiltros);
